import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function ArbitrationLaw() {

  useEffect(() => {
    document.title = "Arbitration Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="/arbitration.jpg" 
              alt="Arbitration and Dispute Resolution" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
              Arbitration and dispute resolution are vital tools for resolving conflicts outside of traditional court proceedings. 
              At Legal Trails, we provide expert legal services to help clients navigate arbitration processes and alternative dispute 
              resolution methods, ensuring they achieve favorable outcomes in a timely and cost-effective manner. Our services include 
              advising clients on arbitration clauses, agreements, and effective strategies for dispute resolution. We represent clients 
              in arbitration proceedings, handling the preparation of pleadings, presentation of evidence, and advocacy before arbitrators. 
              Additionally, we facilitate mediation and negotiation processes to promote amicable settlements and resolve disputes efficiently. 
              Our team also offers legal counsel on the enforcement of arbitration awards and resolutions, and assists clients in exploring 
              alternative methods such as conciliation and early neutral evaluation. With a focus on effective dispute resolution, Legal 
              Trails is committed to guiding clients through every step of the process.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
     
    </div>
     <Footer />
    </>
  );
}

export default ArbitrationLaw;
